/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as DrawerPush } from './drawer-push.story';
export { default as DrawerOverlay } from './drawer-overlay.story';
export { default as DrawerRightSide } from './drawer-right-side.story';
export { default as DrawerResizable } from './drawer-resizable.story';
export { default as DrawerNotCloseable } from './drawer-not-closeable.story';
export { default as DrawerScrollable } from './drawer-scrollable.story';
export { default as DrawerFull } from './drawer-full.story';
export { default as DrawerPortaled } from './drawer-portaled.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import DrawerFullSrcRaw from './drawer-full.story.tsx?raw';
import DrawerNotCloseableSrcRaw from './drawer-not-closeable.story.tsx?raw';
import DrawerOverlaySrcRaw from './drawer-overlay.story.tsx?raw';
import DrawerPortaledSrcRaw from './drawer-portaled.story.tsx?raw';
import DrawerPushSrcRaw from './drawer-push.story.tsx?raw';
import DrawerResizableSrcRaw from './drawer-resizable.story.tsx?raw';
import DrawerRightSideSrcRaw from './drawer-right-side.story.tsx?raw';
import DrawerScrollableSrcRaw from './drawer-scrollable.story.tsx?raw';

export const DrawerPushSrc = removeLicenseHeader(DrawerPushSrcRaw);
export const DrawerOverlaySrc = removeLicenseHeader(DrawerOverlaySrcRaw);
export const DrawerRightSideSrc = removeLicenseHeader(DrawerRightSideSrcRaw);
export const DrawerResizableSrc = removeLicenseHeader(DrawerResizableSrcRaw);
export const DrawerNotCloseableSrc = removeLicenseHeader(
  DrawerNotCloseableSrcRaw,
);
export const DrawerScrollableSrc = removeLicenseHeader(DrawerScrollableSrcRaw);
export const DrawerFullSrc = removeLicenseHeader(DrawerFullSrcRaw);
export const DrawerPortaledSrc = removeLicenseHeader(DrawerPortaledSrcRaw);
